export default __webpack_public_path__ + "static/media/DP6 4A-2EC.03d24d01.jpg";